import { useAccount } from "@/stores/account.ts";

const isOn = (name: string): boolean => {
  const account = useAccount();

  return !!account.$state.features?.find((feature: Feature) => feature.name === name)?.isEnabled;
};

const isOff = (name: string): boolean => !isOn(name);

export { isOn, isOff };
